import { Row } from "@tento-ui/component-builtin";
import { Button } from "@tento-ui/components/button/button";
import { Storybook } from "@tento-ui/ui/storybook";
import { Typography } from "@tento-ui/ui/typography";
import { TaskStatusIndicator } from "./task-status-indicator";
import { TaskStorybook } from "./task-storybook-helpers";

export class TaskStatusIndicatorStoryBook extends Storybook.Default {
  title(): string {
    return "Task Status Indicator";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Status Types",
        render: () => {
          const $planned = TaskStatusIndicator.make();
          $planned.bind("planned");

          const $inProgress = TaskStatusIndicator.make();
          $inProgress.bind("inProgress");

          const $completed = TaskStatusIndicator.make();
          $completed.bind("completed");

          const $autoScheduled = TaskStatusIndicator.make();
          $autoScheduled.bind("autoScheduled");

          return TaskStorybook.createIndicatorGrid({
            items: [
              {
                $indicator: $planned,
                label: "Planned",
              },
              {
                $indicator: $inProgress,
                label: "In Progress",
              },
              {
                $indicator: $completed,
                label: "Completed",
              },
              {
                $indicator: $autoScheduled,
                label: "Auto Scheduled",
              },
            ],
          });
        },
      },
      {
        title: "Interactive Example",
        render: () => {
          const statuses: Array<
            "completed" | "inProgress" | "planned" | "autoScheduled"
          > = ["planned", "inProgress", "completed", "autoScheduled"];
          let currentIndex = 0;

          const $container = Row.make();
          $container.style.alignItems = "center";
          $container.style.gap = "16px";
          $container.style.flexWrap = "wrap";

          const $indicator = TaskStatusIndicator.make();
          $indicator.bind(statuses[currentIndex]);
          $indicator.style.background = "var(--bg-hover)";
          $indicator.style.borderRadius = "4px";
          $indicator.style.flexShrink = "0";

          const $statusLabel = Typography.p(statuses[currentIndex]);
          $statusLabel.style.minWidth = "120px";

          const $button = Button.makeWith("Cycle Status", {
            type: "secondary",
            onClick: () => {
              currentIndex = (currentIndex + 1) % statuses.length;
              $indicator.bind(statuses[currentIndex]);
              $statusLabel.textContent = statuses[currentIndex];
            },
          });

          $container.appendChild($indicator);
          $container.appendChild($statusLabel);
          $container.appendChild($button);

          return $container;
        },
      },
      {
        title: "Hover Effects",
        render: () => {
          const $container = Row.make();
          $container.style.gap = "16px";
          $container.style.alignItems = "center";
          $container.style.flexWrap = "wrap";

          const statuses: Array<
            "completed" | "inProgress" | "planned" | "autoScheduled"
          > = ["planned", "inProgress", "completed", "autoScheduled"];

          for (const status of statuses) {
            const $indicator = TaskStatusIndicator.make();
            $indicator.bind(status);
            $indicator.style.cursor = "pointer";
            $indicator.style.background = "var(--bg-hover)";
            $indicator.style.borderRadius = "4px";
            $indicator.style.flexShrink = "0";
            $container.appendChild($indicator);
          }

          const $label = Typography.small(
            "Hover over indicators to see effects",
          );
          $label.style.color = "var(--text-sec)";
          $label.style.marginLeft = "8px";
          $container.appendChild($label);

          return $container;
        },
      },
    ];
  }
}
